import React from "react";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import UrgentVisitIcon from "../../../components/Icons/UrgentVisitIcon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";


interface IConfirmUrgentVisitToggleContainer {
  onConfirm: () => void;
  onCancel: () => void;
  cancelLabel?: string;
  description?: string;
  showHeader?: boolean;
  onBack?: () => void;
  onClose?: () => void;
}

const ConfirmUrgentVisitToggleContainer = ({
  onConfirm,
  onCancel,
  cancelLabel = "Continue Booking a Doctor Visit",
  // eslint-disable-next-line max-len
  description = "Switching to an Urgent Visit will cancel your Doctor visit. You'll have to start a new booking. What would you like to do?",
  showHeader = false,
  onBack,
  onClose,
}: IConfirmUrgentVisitToggleContainer) => {
  return (
    <div className="flex flex-col justify-between h-full">
      {showHeader && (
        <div className="flex justify-between w-full px-2 pt-1">
          <div>
            {onBack && <ArrowBackIcon onClick={onBack} className="text-light-black cursor-pointer" />}
          </div>
          {onClose && <span onClick={onClose}> <ClearIcon className="cursor-pointer" /></span>}
        </div>
      )}
      <div className="flex items-center h-full">
        <div className="">
          <div className="flex justify-center">
            <div className="flex items-center justify-center bg-taupe-4 rounded-full p-4 h-fit">
              <UrgentVisitIcon width={60} height={60} />
            </div>
          </div>
          <div className="text-2xl font-bold text-center mt-2">
            Book an Urgent Visit?
          </div>
          <p className="text-light-black text-center mt-1.5 2xl:px-8">
            {description}
          </p>
        </div>
      </div>
      <div className="space-y-3 text-center">
        <StyledBookingFlowButton
          color="primary"
          size="small"
          className="w-full"
          onClick={onConfirm}
        >
          Book an Urgent Visit
        </StyledBookingFlowButton>
        <StyledBookingFlowButton
          onClick={onCancel}
          color="primary"
          size="small"
          className="!bg-transparent !border !border-gray-4 !text-black w-full hover:!bg-gray-3 !my-4"
        >
          {cancelLabel}
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default ConfirmUrgentVisitToggleContainer;
